<template>
  <div class="mobileMenu" :class="{'isOpen': isMenuOpen}" :style="styleOptions">
    <template v-if="isLogin">
      <div class="flex items-center justify-between mb-8">
        <div class="flex flex-1 items-center overflow-hidden">
          <div class="relative mr-16">
            <div class="bg-center bg-cover border border-grey-light rounded-full" :style="`background-image: url('${userProfile.avatarUrl}');`" style="padding-top: 38px; width: 40px;"></div>
          </div>
          <div class="text-overflow-ellipsis">
            <span class="font-bold text-lg">{{ userProfile.nickname }}</span>
            <div class="mt-4">
              <div v-if="isPremium" class="flex font-bold text-base items-center leading-normal">
                <premiumImage type="icon" class="mr-4" style="transform: scale(0.85)" />
                <span class="text-premium-dark text-sm">{{ $t('user.premium') }}</span>
              </div>
              <div v-else>
                <span class="font-semibold text-grey text-sm">{{ $t('user.normal') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <router-link :to="{name: 'UserSaved'}" class="mobileMenu__item">
        <img width="36" height="36" class="mr-16" :src="getIconPath('UserSaved')" alt="saved icon" />
        <span>{{ $t('user.save') }}</span>
      </router-link>
      <router-link :to="{name: 'UserHistory'}" class="mobileMenu__item">
        <img width="36" height="36" class="mr-16" :src="getIconPath('UserHistory')" alt="orders icon" />
        <span>{{ $t('user.orders') }}</span>
      </router-link>
      <router-link :to="{name: 'UserPoints'}" class="mobileMenu__item">
        <img width="36" height="36" class="mr-16" :src="getIconPath('UserPoints')" alt="discount icon" />
        <span>{{ $t('user.discount') }}</span>
      </router-link>
      <router-link :to="{name: 'UserInfo'}" class="mobileMenu__item">
        <img width="36" height="36" class="mr-16" :src="getIconPath('UserInfo')" alt="user icon" />
        <span>{{ $t('user.info') }}</span>
      </router-link>
      <router-link v-if="isPremium" :to="{name: 'UserPremium'}" class="mobileMenu__item premium">
        <img width="36" height="36" class="mr-16" :src="getIconPath('UserPremium')"  alt="premium icon" />
        <span>{{ $t('user.premium') }}</span>
      </router-link>
      <hr class="border-b border-grey-lighter" style="margin: 12px 0;">
    </template>
    <router-link class="mobileMenu__item" :to="{ name: 'Socket' }">
      <div class="font-bold relative w-fit">
        {{ $t('chatbot.title') }}
        <div class="absolute bg-red text-white rounded-full text-xs border border-white leading-tight" style="padding: 0 6px; right: -15px; top: -10px;">
          HOT
        </div>
      </div>
    </router-link>
    <!-- <collapse :to-collapse="!isMenuOpen">
      <div class="mobileMenu__item font-bold" slot="title">{{ selectedLangName }}</div>
      <template>
        <ul class="mobileMenu__collapse list-reset">
          <li class="py-12 pl-16" v-for="lang in langsList" :key="lang.code" :class="{'active': selectedLang === lang.code}" @click="switchLang(lang.code)">
            <div class="flex items-center">
              <CountryFlag :country="lang.flag" size='normal' style="margin: 0 -0.7em; border: 1px solid #dddfe2;"/>
              <div class="ml-4">
                {{lang.name}}
              </div>
            </div>
          </li>
        </ul>
      </template>
    </collapse> -->
    <!-- <collapse :to-collapse="!isMenuOpen">
      <div class="mobileMenu__item font-bold" slot="title">{{ selectedCurrency }}</div>
      <template>
        <ul class="mobileMenu__collapse list-reset" @click="toggleMobileMenu">
          <li v-for="(currency, index) in currenciesList" class="py-12 pl-16" :class="{'active': selectedCurrency === currency.code}" @click="switchCurrency(currency.code)" :key="index">
            <span>{{ currency.name }}</span>
            <span class="ml-4">{{ currency.icon }}</span>
          </li>
        </ul>
      </template>
    </collapse> -->
    <div class="mobileMenu__item font-bold" slot="title" @click="langVisible = true">{{ selectedLangName }}</div>
    <div class="mobileMenu__item font-bold" slot="title" @click="currencyVisible = true">{{ selectedCurrency }}</div>
    <router-link class="mobileMenu__item" :to="{ name: 'Promotion' }">
      <div class="font-bold relative w-fit">
        {{ $t('hostAHotel') }}
      </div>
    </router-link>
    <!-- <collapse :to-collapse="!isMenuOpen">
      <div class="mobileMenu__item font-bold" slot="title">{{ $t('hostAHotel') }}</div>
      <template>
        <ul class="mobileMenu__collapse list-reset">
          <li class="py-12 pl-16">
            <router-link :to="{name: 'Promotion'}" class="block no-underline">{{ $t('joinMember') }}</router-link>
          </li>
          <li class="py-12 pl-16">
            <a class="block no-underline" href="https://www.owlting.com/booking/admin?p=dashboard" target="_blank">{{ $t('loginBackstage') }}</a>
          </li>
        </ul>
      </template>
    </collapse> -->
    <button v-if="!isLogin" class="btn btn-solid btn-blue-light mt-24 w-full" @click="this['user/goLogin']">{{ $t('login') }}</button>
    <div v-if="!isPremium" class="mt-36">
      <div class="border border-grey-lightest flex justify-center mt-16 rounded shadow-lg">
        <premiumBanner class="p-16 w-full" />
      </div>
    </div>
    <button v-if="isLogin" class="btn btn-solid btn-blue-light mt-24 mb-56 w-full" @click="logoutHandler">{{ $t('logout') }}</button>
    <el-drawer :visible.sync="currencyVisible" direction="rtl" :append-to-body="true" :show-close="false" custom-class="currency" :with-header="false">
      <div class="fixed w-full p-24 text-lg font-medium flex items-center border-b" style="top: 0;">
        <i class="owl-direction-left text-xl mr-8" @click="closeDrawer"></i>
        <div>{{ $t('currencyTitle') }}</div>
      </div>
      <div class="p-24 text-sm font-bold overflow-y-scroll" style="margin-top: 72px;">
        <li v-for="currency in currenciesList" :key="currency.code"
          class="currency-name list-reset flex items-center justify-between p-8 cursor-pointer rounded-sm"
          :class="currency.name === selectedCurrency && 'bg-blue-lightest'"
          @click="switchCurrency(currency.code)"
        >
          <div class="flex">
            <div>{{ currency.name }}</div>
            <div class="ml-8">{{ currency.currency_name }}</div>
          </div>
          <div v-if="currency.name === selectedCurrency">
            <i class="owl owl-status-check text-blue"></i>
          </div>
        </li>
      </div>
    </el-drawer>
    <el-drawer :visible.sync="langVisible" direction="rtl" :append-to-body="true" :show-close="false" custom-class="lang" :with-header="false">
      <div class="fixed w-full p-24 text-lg font-medium flex items-center border-b" style="top: 0;">
        <i class="owl-direction-left text-xl mr-8" @click="closeDrawer"></i>
        <div>{{ $t('langTitle') }}</div>
      </div>
      <div class="p-24 text-sm font-bold overflow-scroll" style="margin-top: 72px; height: calc(100vh - 72px - 55px)">
        <div class="mb-8 text-xs font-medium">{{ $t('langSelectInfo') }}</div>
        <li v-for="lang in langsList" :key="lang.code"
          class="lang-name list-reset flex items-center justify-between p-8 py-16 cursor-pointer rounded-sm"
          :class="lang.code === selectedLang && 'bg-blue-lightest'"
          @click="switchLang(lang.code)"
        >
          <div class="flex items-center">
            <!-- <CountryFlag :country="lang.flag" size='normal' style="margin: 0 -0.7em; border: 1px solid #dddfe2;"/> -->
            <div class="ml-8">{{ lang.name }}</div>
          </div>
          <div v-if="lang.code === selectedLang">
            <i class="owl owl-status-check text-blue"></i>
          </div>
        </li>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import _ from 'lodash'
import Modal from './index.js'
import { mapActions, mapGetters, mapMutations } from 'vuex'
// import collapse from '@/components/collapse'
import premiumBanner from '@/components/premium/banner'
import iconsMixin from '@/mixins/icons.js'
import CountryFlag from 'vue-country-flag'

export default {
  name: 'mobileMenu',
  mixins: [iconsMixin],
  props: {
  },
  components: {
    // collapse,
    premiumBanner,
    CountryFlag
  },
  data () {
    return {
      top: 0,
      currencyVisible: false,
      langVisible: false
    }
  },
  computed: {
    ...mapGetters({
      langsList: 'user/langsList',
      windowHeight: 'windowHeight',
      userProfile: 'user/profile',
      isLogin: 'user/isLogin',
      selectedLang: 'user/selectedLang',
      selectedLangName: 'user/selectedLangName',
      currenciesList: 'user/currenciesList',
      selectedCurrency: 'user/selectedCurrency',
      selectedCurrencyName: 'user/selectedCurrencyName',
      isMenuOpen: 'user/isMobileMenuOpen',
      isPremium: 'user/isPremium',
      premiumUrl: 'user/premiumUrl'
    }),
    styleOptions: function () {
      return {
        top: this.top + 'px',
        minHeight: this.minHeight,
        height: 'calc(100vh - ' + this.top + 'px)',
        overflowY: 'auto'
      }
    },
    innerHeight: function () {
      return this['windowHeight']
    },
    minHeight: function () {
      return `calc(${this.innerHeight}px - ${this.top}px)`
    }
  },
  methods: {
    ...mapActions([
      'bodyLock',
      'search/updateDateRange',
      'hotels/fetchHotels',
      'search/autoCompleteSearchUpdate',
      'search/setAutoCompleteResult',
      'search/cancelAutoComplete',
      'user/goLogin',
      'user/goLogout',
      'user/switchLang',
      'user/switchCurrency',
      'user/toggleMobileMenu'
    ]),
    ...mapMutations([
      'search/SET_AUTOCOMPLETE_SEARCH_VALUE'
    ]),
    switchLang: function (lang) {
      this['user/switchLang'](lang)
      this.langVisible = false
    },
    switchCurrency: function (currency) {
      this['user/switchCurrency'](currency)
      this.currencyVisible = false
    },
    logoutHandler: function () {
      this['user/goLogout']()
    },
    setTop: function (options) {
      let config = {
        offsetHeight: 0,
        offsetTop: 0,
        ...options
      }
      this.top = config.offsetHeight + config.offsetTop
    },
    toggleMobileMenu: function (bool) {
      const toggleBool = typeof bool === 'boolean' ? bool : !this.isMenuOpen
      console.debug('toggleMobileMenu', bool, typeof bool, toggleBool)

      if (!this.isLoadingHotels) {
        if (!this.isMenuOpen) {
          this.preStateFilters = _.cloneDeep(this.filters)
        }
        this['user/toggleMobileMenu'](toggleBool)
        this.bodyLock(this.isMenuOpen)
      }
    },
    focusTo: function (target) {
      if (typeof target === 'string') {
        this.$nextTick(function () {
          this.$refs[target].focus()
        })
      }
    },
    closeDrawer () {
      this.currencyVisible = false
      this.langVisible = false
    }
  },
  created () {
  },
  mounted () {
  },
  beforeMount () {
    Modal.event.$on('toggle', this.toggleMobileMenu)
    Modal.event.$on('set', this.setTop)
    Modal.event.$on('focus', this.focusTo)
  },
  beforeDestroy () {
    Modal.event.$off('toggle', this.toggleMobileMenu)
    Modal.event.$on('set', this.setTop)
    Modal.event.$off('focus', this.focusTo)
  }
}
</script>

<style lang="sass" scoped>
.mobileMenu
  z-index: 103
  @apply p-16
  @apply w-full bg-white border-grey-lighter border-t-1 fixed ease
  max-height: 100%
  left: 100%
  &.isOpen
    left: 0
  > a
    @apply flex items-center no-underline
  &__item
    @apply font-medium leading-normal text-grey-darkest cursor-pointer no-underline
    padding: 12px 0
    i
      @apply text-grey-light
      &:before
        @apply mr-0
    &.router-link-active, &.router-link-active i
      @apply font-bold text-blue-light
    &.premium
      @apply flex items-center
      i
        color: white
        @apply bg-grey flex items-center justify-center
        width: 16px
        height: 16px
      &.router-link-active
        i
          background-color: $premium
          & + span
            color: $premium
  &__collapse
    li, li a
      @apply font-medium text-grey-dark
      .router-link-active
        @apply text-blue-light
      &.active
        @apply text-blue-light
</style>
<style lang="sass">
.el-drawer.currency, .el-drawer.lang
  width: 100% !important
  .currency-name:not(:first-child)
    @apply mt-16
  .lang-name:not(:first-child)
    @apply mt-16
</style>
